import { Icon } from 'leaflet';
import { useRef, useContext, useEffect } from 'react';
import { useMap, Marker, Popup } from 'react-leaflet';
import { PlatformIndicator } from '../../components/PlatformIndicator';
import { RouteName } from '../../components/RouteName';
import { useMutateGtfsStop } from '../../Queries';
import { ToolsDispatchContext, mainToolset } from '../../ToolsContext';
import { MarkerContextMenu } from './MarkerContextMenu';
import { useQueryGtfsResource } from '../../Queries';


export function MarkerStop({ GStopId, openPopup, isDraggable, specialIcon }) {
  const map = useMap();
  const markerRef = useRef(null);
  const cmRef = useRef(null);
  const toolDispatch = useContext(ToolsDispatchContext);
  const modifyStop = useMutateGtfsStop(); 
  const { isPending, error, data: GStops } = useQueryGtfsResource('stops');

  if (isPending || error || (Object.entries(GStops).length = 0)) {
      return <></>;
  } 

  const GStop = GStops[GStopId];

  const selectedIcon = new Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  const defaultIcon = new Icon.Default;

  useEffect(() => {
    if (openPopup) {
      map.setView([GStop.stop_lat, GStop.stop_lon], 17);
      setTimeout(() => { markerRef.current.openPopup(); }, 250);
    }
  }, [map, GStop.stop_lat, GStop.stop_lon, openPopup, markerRef.current]);

  let icon = defaultIcon;
  if (specialIcon) icon = specialIcon; else {
    icon = isDraggable ? selectedIcon : defaultIcon
  }

  return (
    <Marker ref={markerRef}
      key={GStop.stop_id}
      position={[GStop.stop_lat, GStop.stop_lon]}
      draggable={isDraggable}
      openPopup={openPopup}
      icon={icon}
      eventHandlers={{
        contextmenu: (e) => {
          if (cmRef.current) {
            cmRef.current.show(e.originalEvent);
          }
        },
        dblclick: () => {
          toolDispatch({
            type: 'changed',
            newTool: {
              ...mainToolset.tools.stopsTool,
              selection: GStop.stop_id, // zaznacz przystanek na mapie
              propertyEditor: {
                edit: GStop
              }
            },
          });
        },
        dragend: (e) => {
          const latLng = e.target.getLatLng();
          const data = {
            query: {
              modified_stop_id: GStop.stop_id
            },
            fields: {
              stop_lat: latLng.lat,
              stop_lon: latLng.lng
            }
          };
          modifyStop.mutate(data);
        }
      }}
    >
      <PopupStop GStop={GStop} />
      <MarkerContextMenu cmRef={cmRef} GStop={GStop} />
    </Marker>
  );

}

function PopupStop({GStop}) {
    const routes = (typeof GStop.stats.routes !== 'undefined') ? Object.entries(GStop.stats.routes).map(([, GRoute]) => {
        return (<RouteName GRoute={GRoute} key={GRoute.route_id}></RouteName>);
      }) : [];

    return (
        <Popup>
            <h3>🚏 <span style={{ fontWeight: 'normal' }} className='text-200 text-xs'>{GStop.stop_id}</span> {GStop.stop_name} <PlatformIndicator platformCode={GStop.platform_code} /></h3>
            {(routes.length > 0) ? routes : '❌ Brak linii odjeżdżających z tego stanowiska.'}
        </Popup>
    )
}
